"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useMediaQuery.default;
  }
});

var _useMediaQuery = _interopRequireDefault(require("./useMediaQuery"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/useMediaQuery/index.js
// module id = 228
// module chunks = 0